import { Button } from "@/components/atoms/Button";
import { usePersistResetContext } from "@/hooks/use-persist-reset-context";
import { handleSignOut } from "@/lib/aws-amplify/auth";
import { cn } from "@/lib/tailwind-variants";

export const ErrorRecoveryActions = ({
  className,
}: {
  className: string | undefined;
}) => {
  const resetPersist = usePersistResetContext();

  const handlePageReload = async () => {
    await resetPersist();
    window.location.reload();
  };

  const handleClickSignOut = async () => {
    try {
      await resetPersist();
      await handleSignOut();
      window.location.assign("/");
    } catch (error) {
      console.log("error signing out: ", error);
    }
  };

  return (
    <div className={cn("flex place-content-center gap-4", className)}>
      <Button asChild variant="secondary" size="large">
        {/* Link ではなく素の <a>（＝全文書遷移）。壊れたアプリ状態を引きずらないよう
            SPA 遷移でなくリロードで復帰させる */}
        <a href="/" className="hover:text-primary">
          ホームへ戻る
        </a>
      </Button>
      <Button
        variant="secondary"
        size="large"
        onClick={() => void handlePageReload()}
      >
        ページを更新
      </Button>
      <Button
        variant="secondary"
        size="large"
        onClick={() => void handleClickSignOut()}
      >
        ログアウト
      </Button>
    </div>
  );
};
